import React from 'react'

const ApprovalDelegationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    {...props}
  >
    <path
      d='M10.5471 30.0723V16.9109H12.8805C13.0506 16.9109 13.2207 16.9291 13.3909 16.9655C13.561 17.002 13.7311 17.0445 13.9013 17.0931L24.0002 20.8484C24.3405 20.9699 24.614 21.1886 24.8206 21.5046C25.0272 21.8206 25.1305 22.1487 25.1305 22.489C25.1305 22.9994 24.9542 23.4126 24.6018 23.7286C24.2494 24.0445 23.8423 24.2025 23.3805 24.2025H19.5523C19.4308 24.2025 19.3397 24.1964 19.2789 24.1843C19.2181 24.1721 19.1391 24.1418 19.0419 24.0931L16.7086 23.1817L16.2346 24.6036L19.0419 25.5879C19.0905 25.6122 19.1634 25.6305 19.2607 25.6426C19.3579 25.6548 19.443 25.6609 19.5159 25.6609H29.5055C30.2832 25.6609 30.9638 25.9404 31.5471 26.4994C32.1305 27.0584 32.4221 27.7511 32.4221 28.5775L20.7919 32.9525L10.5471 30.0723ZM1.79712 32.9525V16.9109H7.63045V32.9525H1.79712ZM19.1877 16.9838L12.9898 10.7858L15.068 8.74418L19.1877 12.864L27.4638 4.62439L29.5055 6.66606L19.1877 16.9838Z'
      fill='currentcolor'
    />
  </svg>
)

export default ApprovalDelegationIcon
